import { useState, useEffect } from "react";
import {  useGetAllProductQuery } from "src/services/ProductService";

const useProduct = () => {
    const [product, setProduct] = useState<any[]>([]);
    const [isDataLoading, setIsDataLoading] = useState(true);

    const { data, isLoading, isFetching } = useGetAllProductQuery('');

    useEffect(() => {
        if (isLoading || isFetching) {
            setIsDataLoading(true);
        } else {
            const result: any[] = data?.data;
            setProduct(result || []);
            setIsDataLoading(false);
        }
    }, [data, isLoading, isFetching]);

    return { product, isDataLoading };
};

export default useProduct;
